import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { Provider } from '@angular/core';
import { environment } from '@environments/environment';

/**
 * Custom image loader for Cloudflare CDN.
 *
 * Transforms image URLs to use Cloudflare's image optimization service with:
 * - `format=auto` for automatic WebP/AVIF conversion
 * - `fit=cover` for object-fit behavior
 * - `width` based on requested size
 *
 * @example
 * Input:  https://assets.evoq.fourniergroupe.com/fr/evoq-images.test/image.jpg
 * Output: https://assets.evoq.fourniergroupe.com/cdn-cgi/image/format=auto,fit=cover,width=1920/fr/evoq-images.test/image.jpg
 */
export function fournierImageLoader(config: ImageLoaderConfig): string {
  const { src, width } = config;
  const cdnUrl = environment.CDN.url;

  if (!src.startsWith(cdnUrl)) {
    return src;
  }

  const path = src.slice(cdnUrl.length);
  const imageParams = width ? `format=auto,fit=cover,width=${width}` : 'format=auto,fit=cover';

  return `${cdnUrl}/cdn-cgi/image/${imageParams}${path}`;
}

/**
 * Provider for the Fournier CDN image loader.
 * Add this to your app.config.ts providers array.
 */
export const provideFournierImageLoader = (): Provider => ({
  provide: IMAGE_LOADER,
  useValue: fournierImageLoader,
});
